<script setup lang="ts">
import type { NuxtError } from '#app'
import { checkIsWebView } from '@camelot/webview-utils'
import OfferStatePanel from '~/components/webview/OfferStatePanel.vue'

defineProps<{ error: NuxtError }>()

// The dedicated "Error / Please restart" screen is webview-only. On the web
// the generic fallback is shown (web flows never trigger showError themselves).
const isWebview = computed(() => import.meta.client && checkIsWebView(window))
</script>

<template>
  <div class="min-h-screen container bg-white" data-layout="webview">
    <OfferStatePanel v-if="isWebview" variant="error" />
    <div
      v-else
      class="flex flex-col items-center justify-center min-h-screen gap-12 px-24 text-center"
    >
      <h1>{{ error.statusCode }}</h1>
      <p>{{ error.statusMessage || error.message }}</p>
    </div>
  </div>
</template>
